import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import { IContractInputBaseProps } from '../base/ContractInputBase';
import './ContractInputSection.scss';

interface IContractInputSectionProps
  extends Omit<IContractInputBaseProps, 'name'> {}

const ContractInputSection = ({ id, ...props }: IContractInputSectionProps) => {
  const { itemNameById } = useFormikContractHelpers();

  const { t } = useTranslation();
  return (
    <Contract.Input.Base
      {...props}
      id={id}
      classNames={['contract-section-input']}
      name={`${itemNameById(id)}.content`}
      placeholder={t('input.placeholder.section')}
    />
  );
};

export default ContractInputSection;
